const formatCountryName = (country) => {
  if (!country) return "";

  switch (country.toLowerCase()) {
    case "oman":
      return "Sultanate of Oman";
    default:
      return country; 
  }
};

export default formatCountryName;